module.exports = __webpack_public_path__ + "img/P150T_weapon_154.a4d359f3.png";